import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import SystemHeader from './SystemHeader';
import GuideButton from './shared/GuideButton';
import { CungVeDichAPI } from '../services/API';

const InventoryDashboardForm = ({ userInfo, onLogout, token, totalPoints, accessToken, onRefreshPoints }) => {
  const navigate = useNavigate();
  const [products, setProducts] = useState([]);
  const [initialLoading, setInitialLoading] = useState(true);
  const [message, setMessage] = useState('');
  const [messageType, setMessageType] = useState('');
  const [lastUpdatedDate, setLastUpdatedDate] = useState(null);
  const [selectedImage, setSelectedImage] = useState(null);
  const [showImageModal, setShowImageModal] = useState(false);

  // Helper function for price formatting
  const formatPrice = (value) => {
    if (!value || value === '' || isNaN(parseFloat(value))) return '0';
    return parseFloat(value).toLocaleString('vi-VN');
  };

  // Load products from API
  useEffect(() => {
    const loadProducts = async () => {
      if (!accessToken) {
        console.warn('No access token available for loading products');
        setInitialLoading(false);
        return;
      }

      try {
        setInitialLoading(true);
        console.log('Loading product inventory from API...');

        const result = await CungVeDichAPI.getProductInventory(accessToken);

        if (result.success && result.products) {
          // Get the latest updated date if available
          const productsWithUpdatedAt = result.products.filter(product => product.updatedAt);
          if (productsWithUpdatedAt.length > 0) {
            const latestUpdate = productsWithUpdatedAt.reduce((latest, product) => {
              const productDate = new Date(product.updatedAt);
              const latestDate = new Date(latest);
              return productDate > latestDate ? product.updatedAt : latest;
            }, productsWithUpdatedAt[0].updatedAt);

            setLastUpdatedDate(latestUpdate);
          }

          // Transform API data to form format and filter products with inventory
          const transformedProducts = result.products
            .map(product => ({
              ...product,
              newStock: product.quantity?.toString() || '',
              oldStock: product.extQuantity?.toString() || ''
            }))
            .filter(product => {
              const newStock = parseInt(product.newStock) || 0;
              const oldStock = parseInt(product.oldStock) || 0;
              return newStock > 0 || oldStock > 0;
            });

          setProducts(transformedProducts);
          console.log('Products loaded successfully:', transformedProducts.length);
        } else {
          console.error('Failed to load products:', result);
          setMessage('Không thể tải danh sách sản phẩm từ server');
          setMessageType('error');
        }
      } catch (error) {
        console.error('Error loading products:', error);
        setMessage('Có lỗi xảy ra khi tải danh sách sản phẩm: ' + error.message);
        setMessageType('error');
      } finally {
        setInitialLoading(false);
      }
    };

    loadProducts();
  }, [accessToken]);

  const handleEditInventory = () => {
    // Navigate to edit form
    navigate('/kho-hang/chinh-sua');
  };

  const closeImageModal = () => {
    setShowImageModal(false);
    setSelectedImage(null);
  };

  return (
    <div className="min-h-screen bg-gray-50">
      <SystemHeader
        userInfo={userInfo}
        onLogout={onLogout}
        totalPoints={totalPoints}
        pageTitle="Báo cáo kho hàng"
        pageSubtitle="Xem thông tin kho sản phẩm"
        onRefreshPoints={onRefreshPoints}
      />

      <div className="max-w-4xl mx-auto px-4 sm:px-4 lg:px-6">
        {/* Back button */}
        <div className="py-2 flex items-center gap-2">
          <button onClick={() => navigate('/dashboard')}
            className="flex items-center gap-1.5 px-3 py-2 rounded-lg text-sm font-medium transition-colors"
            style={{ color: '#2563eb', background: '#2563eb12' }}>
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="m15 18-6-6 6-6"/></svg>
            <span>Quay lại</span>
          </button>
          <GuideButton slug="huong-dan-kho-hang" />
        </div>
        <div className="bg-white rounded-lg shadow-sm border flex flex-col h-[calc(100vh-200px)]">

          <div className="flex flex-col flex-1">
            {/* Message Display */}
            {message && (
              <div className={`mx-6 mt-6 p-4 rounded-lg flex-shrink-0 ${messageType === 'success'
                ? 'bg-green-50 text-green-800 border border-green-200'
                : 'bg-red-50 text-red-800 border border-red-200'
                }`}>
                {message}
              </div>
            )}

            {/* Summary Statistics - Compact */}
            <div className="py-3 border-b border-gray-200 flex-shrink-0 bg-blue-50">
              <div className="grid grid-cols-2 gap-3">
                {/* <div className="bg-white rounded p-3 border border-green-200">
                  <div className="flex items-center justify-between">
                    <div className="flex items-center">
                      <div className="w-6 h-6 bg-green-100 rounded-full flex items-center justify-center mr-2">
                        <svg className="w-3 h-3 text-green-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5H7a2 2 0 00-2 2v10a2 2 0 002 2h8a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2" />
                        </svg>
                      </div>
                      <span className="text-xs font-medium text-gray-500">Cty cũ</span>
                    </div>
                    <span className="text-sm font-semibold text-gray-900">
                      {products.reduce((total, product) => {
                        const quantity = parseInt(product.oldStock) || 0;
                        return total + quantity;
                      }, 0).toLocaleString()}
                    </span>
                  </div>
                </div> */}
                {/* <div className="bg-white rounded p-3 border border-blue-200">
                  <div className="flex items-center justify-between">
                    <div className="flex items-center">
                      <div className="w-6 h-6 bg-blue-100 rounded-full flex items-center justify-center mr-2">
                        <svg className="w-3 h-3 text-blue-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M20 7l-8-4-8 4m16 0l-8 4m8-4v10l-8 4m0-10L4 7m8 4v10M4 7v10l8 4" />
                        </svg>
                      </div>
                      <span className="text-xs font-medium text-gray-500">Cty mới</span>
                    </div>
                    <span className="text-sm font-semibold text-gray-900">
                      {products.reduce((total, product) => {
                        const quantity = parseInt(product.newStock) || 0;
                        return total + quantity;
                      }, 0).toLocaleString()}
                    </span>
                  </div>
                </div> */}
                <div className="bg-white rounded p-3 border border-purple-200">
                  <div className="flex items-center justify-between">
                    <div className="flex items-center">
                      <div className="w-6 h-6 bg-purple-100 rounded-full flex items-center justify-center mr-2">
                        <svg className="w-3 h-3 text-purple-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 7h6m0 10v-3m-3 3h.01M9 17h.01M9 14h.01M12 14h.01M15 11h.01M12 11h.01M9 11h.01M7 21h10a2 2 0 002-2V5a2 2 0 00-2-2H7a2 2 0 00-2 2v14a2 2 0 002 2z" />
                        </svg>
                      </div>
                      <span className="text-xs font-medium text-gray-500">Tổng số lượng</span>
                    </div>
                    <span className="text-sm font-semibold text-gray-900">
                      {products.reduce((total, product) => {
                        const newStock = parseInt(product.newStock) || 0;
                        const oldStock = parseInt(product.oldStock) || 0;
                        return total + newStock + oldStock;
                      }, 0).toLocaleString()}
                    </span>
                  </div>
                </div>
                <div className="bg-white rounded p-3 border border-orange-200">
                  <div className="flex items-center justify-between">
                    <div className="flex items-center">
                      <div className="w-6 h-6 bg-orange-100 rounded-full flex items-center justify-center mr-2">
                        <svg className="w-3 h-3 text-orange-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                        </svg>
                      </div>
                      <span className="text-xs font-medium text-gray-500">Tổng giá trị</span>
                    </div>
                    <span className="text-sm font-semibold text-gray-900">
                      {products.reduce((total, product) => {
                        const newStock = parseInt(product.newStock) || 0;
                        const oldStock = parseInt(product.oldStock) || 0;
                        const price = parseFloat(product.price) || 0;
                        return total + ((newStock + oldStock) * price);
                      }, 0).toLocaleString()}₫
                    </span>
                  </div>
                </div>
              </div>

              {/* Company Notes - Compact */}
              {/* <div className="mt-3 p-2 bg-yellow-50 border border-yellow-200 rounded">
                <div className="flex items-center">
                  <svg className="w-4 h-4 text-yellow-600 mr-2 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                  </svg>
                  <div className="text-xs text-yellow-700">
                    <div><span className="font-medium">Cty đưa sản phẩm ra thị trường:</span></div>
                    <div><span className="font-medium">Cty cũ:</span> Yody Phương Anh • <span className="font-medium">Cty mới:</span> Yody Tomorrow & Green Natural</div>
                  </div>
                </div>
              </div> */}
            </div>

            {/* Products List - Popup Style */}
            <div className="flex-1 overflow-y-auto">
              {initialLoading ? (
                <div className="flex items-center justify-center py-8">
                  <div className="w-8 h-8 border-4 border-blue-500 border-t-transparent rounded-full animate-spin"></div>
                  <span className="ml-3 text-gray-600">Đang tải danh sách sản phẩm...</span>
                </div>
              ) : products.length === 0 ? (
                <div className="text-center py-8">
                  <p className="text-gray-500">Không có sản phẩm nào có trong kho</p>
                </div>
              ) : (
                <div className="bg-gray-50 rounded-lg border border-gray-200 overflow-hidden">
                  <div className="overflow-x-auto">
                    <table className="w-full border-collapse">
                      <thead className="bg-gray-50 sticky top-0 z-10">
                        <tr>
                          <th className="px-2 py-2 text-left text-xs font-medium text-gray-500 uppercase tracking-wider border-b border-gray-200">
                            Sản phẩm
                          </th>
                          <th className="px-1 py-2 text-center text-xs font-medium text-gray-500 uppercase tracking-wider border-b border-gray-200 w-16">
                            Số lượng
                          </th>
                          <th className="px-1 py-2 text-center text-xs font-medium text-gray-500 uppercase tracking-wider border-b border-gray-200 w-20">
                            Đơn giá
                          </th>
                          {/* <th className="px-1 py-2 text-center text-xs font-medium text-gray-500 uppercase tracking-wider border-b border-gray-200 w-16">
                            Cty cũ
                          </th> */}
                          <th className="px-1 py-2 text-center text-xs font-medium text-gray-500 uppercase tracking-wider border-b border-gray-200 w-20">
                            Thành tiền
                          </th>
                        </tr>
                      </thead>
                      <tbody className="bg-white divide-y divide-gray-200">
                        {products
                          .filter(product => {
                            const oldStock = parseInt(product.oldStock) || 0;
                            const newStock = parseInt(product.newStock) || 0;
                            return (oldStock + newStock) > 0;
                          })
                          .map((product, index) => {
                            const oldStock = parseInt(product.oldStock) || 0;
                            const newStock = parseInt(product.newStock) || 0;

                            return (
                              <tr key={product.id} className="hover:bg-gray-50">
                                <td className="px-2 py-2">
                                  <div className="flex items-center space-x-2">
                                    <div className="text-xs font-medium text-gray-900 flex-1">
                                      {product.name}
                                    </div>
                                  </div>
                                </td>
                                {/* <td className="px-1 py-2 text-center text-xs text-gray-600">
                                  {oldStock.toLocaleString()}
                                </td> */}
                                <td className="px-1 py-2 text-center text-xs text-gray-600">
                                  {newStock.toLocaleString()}
                                </td>
                                <td className="px-1 py-2 text-center text-xs text-gray-600">
                                  {formatPrice(product.price)}
                                </td>
                                <td className="px-1 py-2 text-center text-xs font-semibold text-blue-700">
                                  {formatPrice((oldStock + newStock) * (product.price || 0))}
                                </td>
                              </tr>
                            );
                          })}
                      </tbody>
                      <tfoot className="bg-gray-50 border-t border-gray-200">
                        <tr>
                          <td className="px-2 py-2 text-xs font-bold text-gray-900">
                            Tổng cộng
                          </td>
                          <td className="px-1 py-2">
                            <div className="w-full px-1 py-1 text-xs bg-gray-200 border border-gray-300 rounded text-center font-bold text-gray-900" style={{ minWidth: '45px', minHeight: '32px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                              {products
                                .reduce((total, product) => total + (parseInt(product.newStock) || 0), 0)
                                .toLocaleString()}
                            </div>
                          </td>
                          <td className="px-1 py-2"></td>
                          <td className="px-1 py-2">
                            <div className="w-full px-1 py-1 text-xs bg-orange-100 border border-orange-300 rounded text-center font-bold text-orange-600" style={{ minWidth: '45px', minHeight: '32px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                              {products
                                .reduce((total, product) => {
                                  const oldStock = parseInt(product.oldStock) || 0;
                                  const newStock = parseInt(product.newStock) || 0;
                                  const price = parseFloat(product.price) || 0;
                                  return total + ((oldStock + newStock) * price);
                                }, 0)
                                .toLocaleString()}₫
                            </div>
                          </td>
                        </tr>
                      </tfoot>
                    </table>
                  </div>
                </div>
              )}
            </div>

            {/* Lưu ý quan trọng - giống popup */}
            <div className="mt-6 mb-4 p-3 bg-red-50 border border-red-200 rounded-lg">
              <div className="flex items-start">
                <svg className="w-4 h-4 text-red-600 mr-2 mt-0.5 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.964-.833-2.732 0L3.732 16.5c-.77.833.192 2.5 1.732 2.5z" />
                </svg>
                <div className="text-xs text-red-700">
                  <span className="font-medium">Lưu ý:</span> Vui lòng kiểm tra kỹ thông tin trước khi xác nhận. Chụp ảnh báo cáo gửi cấp trên để duyệt.
                </div>
              </div>
            </div>

            {/* Ngày cập nhật kho hàng gần nhất */}
            {lastUpdatedDate && (
              <div className="mb-4 p-3 bg-green-50 border border-green-200 rounded-lg">
                <div className="flex items-center">
                  <svg className="w-4 h-4 text-green-600 mr-2 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
                  </svg>
                  <div className="text-xs text-green-700">
                    <span className="font-medium">Ngày cập nhật kho hàng gần nhất:</span> {new Date(lastUpdatedDate).toLocaleDateString('vi-VN', {
                      day: '2-digit',
                      month: '2-digit',
                      year: 'numeric',
                      hour: '2-digit',
                      minute: '2-digit'
                    })}
                  </div>
                </div>
              </div>
            )}

            {/* Action Button - Fixed at bottom */}
            <div className="flex-shrink-0 border-t border-gray-200 bg-white py-4">
              <div className="flex flex-col sm:flex-row gap-4">
                <button
                  type="button"
                  onClick={handleEditInventory}
                  className="flex-1 bg-blue-600 text-white py-3 rounded-lg font-medium hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 transition-colors"
                >
                  Cập nhật kho hàng
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Image Modal */}
      {showImageModal && selectedImage && (
        <div className="fixed inset-0 bg-black bg-opacity-75 flex items-center justify-center z-50 p-4">
          <div className="bg-white rounded-lg shadow-xl max-w-4xl max-h-[90vh] overflow-hidden">
            <div className="p-4 border-b border-gray-200">
              <div className="flex items-center justify-between">
                <h3 className="text-lg font-semibold text-gray-900">{selectedImage.name}</h3>
                <button
                  onClick={closeImageModal}
                  className="text-gray-400 hover:text-gray-600 transition-colors"
                >
                  <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                  </svg>
                </button>
              </div>
            </div>
            <div className="p-4">
              <img
                src={selectedImage.url}
                alt={selectedImage.name}
                className="w-full h-auto max-h-[60vh] object-contain rounded-lg mb-4"
                onError={(e) => {
                  e.target.src = 'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAwIiBoZWlnaHQ9IjIwMCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cmVjdCB3aWR0aD0iMjAwIiBoZWlnaHQ9IjIwMCIgZmlsbD0iI2Y3ZjdmNyIvPjx0ZXh0IHg9IjUwJSIgeT0iNTAlIiBmb250LWZhbWlseT0iQXJpYWwiIGZvbnQtc2l6ZT0iMTQiIGZpbGw9IiM5OTk5OTkiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGR5PSIuM2VtIj5JbWFnZSBub3QgZm91bmQ8L3RleHQ+PC9zdmc+';
                }}
              />
              {selectedImage.description && (
                <div className="mt-4 p-3 bg-gray-50 rounded-lg">
                  <h4 className="text-sm font-medium text-gray-700 mb-2">Mô tả sản phẩm:</h4>
                  <p className="text-xs text-gray-600 leading-relaxed">
                    {selectedImage.description}
                  </p>
                </div>
              )}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default InventoryDashboardForm;
